var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.862,
    height: 64.861,
    viewBox: "0 0 64.862 64.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_akar-link-chain",
    "data-name": "Icon akar-link-chain",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M38.393,17.876a14.041,14.041,0,0,0-19.852,0L8.612,27.8A14.04,14.04,0,1,0,28.467,47.658l4.963-4.963",
    transform: "translate(0 10.591)",
    fill: "none",
    stroke: "#eb506c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M15.684,38.393a14.041,14.041,0,0,0,19.852,0l9.929-9.926A14.04,14.04,0,1,0,25.61,8.612l-4.963,4.963",
    transform: "translate(12.783)",
    fill: "none",
    stroke: "#eb506c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.f2ea44ff775964f54b8c34a5b1f18903.svg";
export { ForwardRef as ReactComponent };